// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://shdgddnvnluislrlkmbh.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNoZGdkZG52bmx1aXNscmxrbWJoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQyMTAyMzQsImV4cCI6MjA2OTc4NjIzNH0.hyoUTJB3EFfaxVkoUkGELpgIO6qJ1y9GFUUSB_fkySw";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});